<div fxLayout="column" fxLayoutGap="6px">
  <iot-platform-ui-detail-popup-section-header headerTitle="{{ 'IOT_DICTIONARY.routes' | translate }}" />

  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field color="accent" fxFlex="100%">
      <mat-label style="font-size: 12px">{{ 'IOT_DICTIONARY.DAYS_TO_DISPLAY' | translate }}</mat-label>
      <mat-select (selectionChange)="onLoadRoutes($event.value)">
        @for (hour of hours; track hour) {
          <mat-option [value]="hour">{{ hour.display }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
